import NumberFormat from 'react-number-format';
import { useField } from 'react-final-form';
import React from 'react';
import {
  FormControl, FormErrorMessage, Input,
} from '@chakra-ui/react';
import FieldLabel from './FieldLabel';

interface CurrencyInputControlProps {
  name: string;
  label: string;
  isRequired?: boolean;
  // item 434 — the invoice's Discount is a SIGNED adjustment (deposit splits store a
  // negative); the default no-negatives input silently flipped the sign on save and
  // INFLATED the total. Opt in where signed values are real.
  allowNegative?: boolean;
}
const CurrencyInputControl: React.FC<CurrencyInputControlProps> = ({
  name, label, isRequired, allowNegative,
}) => {
  const { input, error, touched } = useField(name);
  return (
    <FormControl isInvalid={error && touched} isRequired={isRequired}>
      <FieldLabel htmlFor={name}>{label}</FieldLabel>
      <NumberFormat
        customInput={Input}
        thousandSeparator=","
        decimalScale={2}
        fixedDecimalScale
        allowNegative={!!allowNegative}
        autoComplete="off"
        // dart (2026-07-15, Chad) — show EMPTY (→ placeholder) when the value is 0, instead of a
        // literal "0.00" you have to clear before typing. A blank field saves as 0 downstream.
        value={input.value || ''}
        onBlur={input.onBlur}
        onFocus={input.onFocus}
        onValueChange={({ floatValue }) => input.onChange(floatValue)}
        isInvalid={error && touched}
        id={name}
        placeholder={label}
      />
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  );
};
CurrencyInputControl.defaultProps = {
  isRequired: false,
  allowNegative: false,
};
export default CurrencyInputControl;
